import { useNavigate, useLocation } from "react-router-dom";

const useTrimPath = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const trimPath = () => {
		const pathSegments = location.pathname.split("/").filter(Boolean);
		if (pathSegments.length > 1) {
			pathSegments.pop(); // Remove the last segment
		}
		const newPath = `/${pathSegments.join("/")}`;
		navigate(newPath, { replace: true }); // Update the URL without refreshing the page
	};

	return trimPath;
};

export default useTrimPath;
